import { useTranslation } from 'react-i18next'

const TimelineChatbotItemMenu = ({
  onEditProgrammation,
  onEditNodes,
  onDuplicate,
  onDelete,
}: {
  onEditProgrammation: () => void
  onEditNodes: () => void
  onDuplicate: () => void
  onDelete: () => void
}) => {
  const { t } = useTranslation()

  return (
    <div className="c-absolute c-shadow-xl c-left-0 c-top-[calc(100%+4px)] c-w-64 c-z-10 c-border c-border-grey-500 c-bg-white c-rounded-md c-overflow-hidden">
      <button
        onClick={onEditProgrammation}
        className="c-w-full c-text-left c-px-4 c-py-3 c-text-sm hover:c-bg-secondary-300 c-transition-colors c-border-b c-border-grey-500"
      >
        {t('pages.configuration.followups.chatbot.menu.edit-step1')}
      </button>
      <button
        onClick={onEditNodes}
        className="c-w-full c-text-left c-px-4 c-py-3 c-text-sm hover:c-bg-secondary-300 c-transition-colors c-border-b c-border-grey-500"
      >
        {t('pages.configuration.followups.chatbot.menu.edit-step2')}
      </button>
      <button
        onClick={onDuplicate}
        className="c-w-full c-text-left c-px-4 c-py-3 c-text-sm hover:c-bg-secondary-300 c-transition-colors c-border-b c-border-grey-500"
      >
        {t('pages.configuration.followups.chatbot.menu.duplicate')}
      </button>
      <button
        onClick={onDelete}
        className="c-w-full c-text-left c-px-4 c-py-3 c-text-sm hover:c-bg-secondary-300 c-transition-colors c-text-red-600"
      >
        {t('pages.configuration.followups.chatbot.menu.delete')}
      </button>
    </div>
  )
}

export { TimelineChatbotItemMenu }
